import { gql } from '@apollo/client';

import {
  type OrganizationSwitcherMembershipsQuery_thisUserInfo_UserInfo_memberships_OrganizationMembership,
  useOrganizationSwitcherMembershipsQuery,
} from 'src/generated/mloop-graphql';

import useAuth from 'src/hooks/useAuth';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const OrganizationSwitcherMemberships = gql`
  query OrganizationSwitcherMemberships {
    thisUserInfo {
      userId
      memberships {
        organization {
          id
          name
        }
        isActive
      }
    }
  }
`;

/** One Organization the acting user can switch to, as the switcher renders it. */
export type OrganizationMembership =
  OrganizationSwitcherMembershipsQuery_thisUserInfo_UserInfo_memberships_OrganizationMembership;

/**
 * Reads the Organizations the acting user is a member of, oldest Organization first.
 *
 * Answers an empty list while a staffer impersonates a customer. The mutation refuses an
 * impersonated switch anyway (`SwitchActiveOrganizationNotAllowedWhileImpersonatingError`), but a
 * staffer must not even be offered a control that moves someone else's Organization.
 */
export const useOrganizationMemberships = (): readonly OrganizationMembership[] => {
  const { userInfo } = useAuth();
  const isImpersonating = Boolean(userInfo?.impersonatingUserInfo);

  const { data } = useOrganizationSwitcherMembershipsQuery({ skip: isImpersonating });

  if (isImpersonating) {
    return [];
  }
  return data?.thisUserInfo?.memberships ?? [];
};
